// import React from 'react';
// import Tabs from '../../common_components/Tabs';
// import Filters from './Filterbtn';
// import Table from './Table';
// import Pagination from './Pagination';

// const MainContent = ({ rollId }) => {
//   return (
//     <div className="mt-2 main-content1">
//       <Tabs />

//       <div className="ps-lg-4 ps-md-4 pt-4 maincontent-container1 mt-2">
//         <Filters rollId={rollId} />

//         <div className="table-pagination-container shadow-sm p-3 m-lg-3 bg-white rounded">
//           <Table rollId={rollId}  />
//           <div className="d-flex justify-content-end mt-5">
//             <Pagination />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MainContent;

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Tabs from "../../CommonComponents/Tabs";
import Filters from "./Filterbtn";
import Table from "./Table";
import Pagination from "./Pagination";
import { useRollId } from "../../CommonComponents/RollIdContext";
import AccmulativeRequestContainer from "../../AccumulativeRequest/AccmulativeRequestContainer";
import ReversalAccumulativeRequestContainer from "../../ReversalAccumulativeRequest/ReversalAccumulativeRequestContainer";
import ReversalIncomingRequestContainer from "../../ReversalIncomingRequest/ReversalIncomingRequestContainer";

const MainContent = ({ reload, accumulativeRequest, reversalAccumulativeRequest, reversalIncomingRequest }) => {
  const { rollId } = useRollId();
  const location = useLocation();
  const [filters, setFilters] = useState({
    date: "",
    time: "",
    currency: "",
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTP] = useState(0);

  useEffect(() => {
    setFilters({
      date: "",
      time: "",
      currency: "",
    });
    setPage(1);
  }, [location.pathname]);

  return (
    <div className="container-fluid main-content-table bgColor d-flex flex-column overflow-hidden mt-2">
      <hr />

      {/* Main Content Wrapper */}
      <div className="flex-grow-1 d-flex flex-column pt-2">
        {accumulativeRequest ? (
          <AccmulativeRequestContainer />
        ) : reversalAccumulativeRequest ? (
          <ReversalAccumulativeRequestContainer />
        ) : reversalIncomingRequest ? (
          <ReversalIncomingRequestContainer />
        ) : (
          <>
            {/* Filters */}
            <div className="mt-3">
              <Filters filters={filters} setFilters={setFilters} />
            </div>

            {/* Table and Pagination Container */}
            <div className="table-wrapper marginRight flex-grow-1 p-3 rounded shadow-sm d-flex flex-column">
              <div
                className="table-container scroll flex-grow-1"
              >
                <Table
                  reload={reload}
                  filters={filters}
                  setTotalPages={setTP}
                  page={page}
                  setPage={setPage}
                />
              </div>

              {/* Pagination */}
              <div className="pagination-container mt-2 me-3">
                <Pagination
                  totalPages={totalPages}
                  page={page}
                  setPage={setPage}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default MainContent;
